import axios from "axios";
import { getConfig } from "../config/config";

interface ConsultaParams {
  gpc?: string;
  ncm?: string;
  cnpj?: string;
  pagina?: number;
  pagina_cnpj?: number;
  confirmar?: boolean;
}

export async function consultarGpcNcm(
  token: string,
  filtros: ConsultaParams
): Promise<any> {
  try {
    const queryParams = new URLSearchParams();

    Object.entries(filtros).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, String(value));
      }
    });

    const response = await axios.get(
      `${getConfig().API_URL}/consultaGpcNcm?${queryParams.toString()}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      }
    );

    return {
      success: true,
      message: '',
      result: response.data
    };

  } catch (error: any) {
    return {
      success: false,
      message: error?.message || 'Erro desconhecido',
      result: null
    };
  }
}
